import { noOpStrategy } from '../strategies';

/**
 * @typedef {typeof import('./factoryTypes').PersistentStorageStrategyFactory} PersistentStorageStrategyFactoryI
 * @typedef {import('../strategies/strategyTypes').PersistentStorageStrategy} PersistentStorageStrategy
 */

/** @type {PersistentStorageStrategyFactoryI} */
export class PersistentStorageStrategyFactory {
  /**
   * @type Array.<PersistentStorageStrategy>
   */
  strategies = [];

  register(strategy) {
    this.strategies.push(strategy);
  }

  /**
   * get first accessible registered strategy or return noOp stragegy if none found
   */
  getStrategy() {
    return (
      this.strategies.find(strategy => strategy.isSupported()) || noOpStrategy
    );
  }
}
